import React, { Component } from 'react';
import Icon from './Icon.js';
import './Svg.scss';
import './Icon.scss';

export default class ExpandIcon extends Component {
    render () {
        let finalClassName = "lds-message " + Icon.buildCssClass(this.props);

        return (
          <svg className={finalClassName} width="100px" height="30px" viewBox="35 30 30 30"><g transform="translate(25 50)">
          <circle cx="0" cy="0" r="6">
            <animateTransform attributeName="transform" type="scale" begin="-0.3333333333333333s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
          </circle>
          </g><g transform="translate(50 50)">
          <circle cx="0" cy="0" r="6">
            <animateTransform attributeName="transform" type="scale" begin="-0.16666666666666666s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
          </circle>
          </g><g transform="translate(75 50)">
          <circle cx="0" cy="0" r="6">
            <animateTransform attributeName="transform" type="scale" begin="0s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
          </circle>
          </g></svg>
        )
      }
    }


// WEBPACK FOOTER //
// ./src/components/icon/Loading.js